import React, {ReactNode} from 'react';
import lottie from 'lottie-web';

import * as animationData from '@assets/loader.json';
class AppLoader extends React.PureComponent {
  animBox: HTMLDivElement | null | undefined;

  componentDidMount(): void {
    if (this.animBox) {
      const animation = lottie.loadAnimation({
        container: this.animBox,
        loop: true,
        autoplay: true,
        animationData: (animationData as any).default,
        renderer: 'svg'
      });
      animation.play();
      animation.setSpeed(1.75);
    }
  }

  render(): ReactNode {
    return (
      <div className="flex-centering">
        <div
          className="app-loader"
          ref={ref => {
            this.animBox = ref;
          }}
        />
      </div>
    );
  }
}

export default AppLoader;
